<template>
  <div :class="$style.productCard" @click="handleClick">
    <!-- 商品图片 -->
    <div :class="$style.productImage">
      <van-image
        :src="product.commodityCoverPic"
        :alt="product.commodityTitle"
        fit="cover"
        lazy-load
      />
    </div>

    <!-- 商品信息 -->
    <div :class="$style.productInfo">
      <!-- 商品标题 -->
      <div :class="$style.productTitle">{{ product.commodityTitle }}</div>

      <!-- 店铺名称 -->
      <div :class="$style.shopName">{{ product.storeName }}</div>

      <!-- 价格和销量 -->
      <div :class="$style.priceRow">
        <div :class="$style.price">
          <span :class="$style.priceSymbol">¥</span>
          <span :class="$style.priceValue">{{ product.commodityPrice }}</span>
        </div>
        <div :class="$style.sales">销量 {{ product.saleCount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'ProductSection',

    props: {
      product: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      targetUrl() {
        const env = process.env.NODE_ENV === 'development' ? 'h5-test' : 'h5'

        return `https://h5.gogpay.cn/${env}/app/duoduo-mall/#/goods/index?isFull=true&isLogin=true&isAuth=true&id=${this.product.commodityId}`
      },
    },
    methods: {
      handleClick() {
        this.$emit('clickService')
        this.$handleResourceClick({
          ...this.product,
          targetUrl: this.targetUrl,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .productCard {
    display: flex;
    box-sizing: border-box;
    padding: 12px 0;
    border-bottom: 1px solid rgba(152, 152, 152, 0.1);
  }

  .productImage {
    width: 90px;
    height: 90px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
    margin-right: 8px;
    background-color: #f5f5f5;
  }

  .productInfo {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 90px;
  }

  .productTitle {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .shopName {
    font-size: 12px;
    color: #666;
    line-height: 17px;
  }

  .priceRow {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 7px;
  }

  .price {
    display: flex;
    align-items: baseline;

    .priceSymbol {
      font-size: 12px;
      color: #ff3b30;
      font-weight: 500;
    }

    .priceValue {
      font-size: 16px;
      color: #ff3b30;
      font-weight: 500;
      margin-left: 2px;
    }
  }

  .sales {
    font-size: 12px;
    color: #b4b4b4;
    line-height: 17px;
  }
</style>
